<template>
  <div
    class="c-player-popup"
    :class="[ isEmbedded ? 'c-player-popup--dark' : 'c-player-popup--light' ]"
  >
    <div class="c-player-popup__container c-player-popup__container--narrow">
      <div class="c-player-popup__circle">
        18<span>+</span>
      </div>
      <div v-if="isEmbedded">
        <h5 class="o-typography__headline4 u-text-center">
          {{ $t('player.adult.info') }}
        </h5>
        <h5 class="o-typography__headline4 u-text-center">
          {{ $t('player.adult.embeddedConfirmation') }}
        </h5>
      </div>
      <div v-else>
        <h1 class="o-typography__headline2 u-text-center u-mt-0">
          {{ $t('player.adult.title') }}
        </h1>
        <div class="o-separator o-separator--accent o-separator--verify-age"></div>
        <h5
          v-if="!isMobile"
          class="o-typography__headline4 u-text-center"
        >
          {{ $t('player.adult.longInfo') }}
        </h5>
        <h5 class="o-typography__headline4 u-text-center">
          {{ $t('player.adult.confirmation') }}
        </h5>
      </div>

      <div class="o-button__container">
        <div
          v-accessibility-focus="() => $emit('confirmed')"
          class="o-button o-button--large-spacing o-button--red-border o-button--low"
          :class="{ 'o-button--color-white': isEmbedded }"
        >
          <span class="o-typography__label u-uppercase">
            {{ $t('common.yes') }}
          </span>
        </div>
        <div
          v-accessibility-focus="() => $emit('rejected')"
          class="o-button o-button--large-spacing o-button--red-border o-button--low u-ml-30"
          :class="{ 'o-button--color-white': isEmbedded }"
        >
          <span class="o-typography__label u-uppercase">
            {{ $t('common.no') }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { NavigationContextManager } from '@/shared/utils/accessibility';

  export default {
    name: 'UiPlayerVerifyAge',
    props: {
      isEmbedded: {
        type: Boolean,
      },
    },
    computed: {
      isMobile() {
        return this.$window.isMobileView;
      },
    },
    mounted() {
      NavigationContextManager.pushContext(this.$el, () => this.$emit('rejected'), { savePrevFocus: true, skipFocus: true });
    },
    beforeDestroy() {
      NavigationContextManager.popContext();
    },
  };
</script>
